import React, { useState } from "react";
import { useParams, Link } from "react-router-dom";
import { carsData } from "../components/data/carsData";
import "../styles/ModelPage.css";

const ModelPage = () => {
  const { brand, model } = useParams();
  const [sortBy, setSortBy] = useState("relevance");

  const brandData = carsData[brand];
  const modelData = brandData?.models.find(
    (m) => m.model.toLowerCase().replace(/\s+/g, '-') === model.toLowerCase()
  );

  if (!modelData) {
    return (
      <div className="model-page">
        <div className="not-found">
          <h2>No cars available for this model.</h2>
          <Link to={`/brand/${brand}`} className="back-btn">← Back to {brandData?.brandName}</Link>
        </div>
      </div>
    );
  }

  const sortedCars = [...modelData.variants].sort((a, b) => {
    if (sortBy === "price-low") {
      return parseFloat(a.price.replace(/[^0-9.]/g, '')) - parseFloat(b.price.replace(/[^0-9.]/g, ''));
    }
    if (sortBy === "price-high") {
      return parseFloat(b.price.replace(/[^0-9.]/g, '')) - parseFloat(a.price.replace(/[^0-9.]/g, ''));
    }
    if (sortBy === "year-new") {
      return parseInt(b.year) - parseInt(a.year);
    }
    if (sortBy === "year-old") {
      return parseInt(a.year) - parseInt(b.year);
    }
    return 0;
  });

  return (
    <div className="model-page">
      <div className="model-hero">
        <h1>{modelData.model} <span className="highlight">Used Cars</span></h1>
        <p className="car-count-badge">{modelData.variants.length} Premium {modelData.variants.length === 1 ? 'Car' : 'Cars'} Available</p>
      </div>

      <div className="filters-bar">
        <div className="sort-container">
          <label className="sort-label">
            <span className="sort-icon">⚡</span>
            Sort by:
          </label>
          <select value={sortBy} onChange={(e) => setSortBy(e.target.value)} className="sort-select">
            <option value="relevance">Best Match</option>
            <option value="price-low">Price: Low to High</option>
            <option value="price-high">Price: High to Low</option>
            <option value="year-new">Year: Newest First</option>
            <option value="year-old">Year: Oldest First</option>
          </select>
        </div>
      </div>

      <div className="cars-showcase">
        {sortedCars.map((car) => (
          <Link to={`/car/${car.id}`} key={car.id} className="car-showcase-card">
            <div className="car-image-wrapper">
              <img src={car.image} alt={car.name} className="car-image" />
              {car.assured && (
                <div className={`assured-shield ${car.assuredPlus ? 'plus' : ''}`}>
                  <span className="shield-check">✓</span>
                  <span className="shield-text">Assured{car.assuredPlus && '+'}</span>
                </div>
              )}
              <div className="image-overlay">
                <span className="view-text">View Details →</span>
              </div>
            </div>

            <div className="car-info-section">
              <h3 className="car-name">{car.name}</h3>
              
              <div className="specs-row">
                <div className="spec-badge">
                  <span className="icon">📏</span>
                  <span>{car.kmDriven}</span>
                </div>
                <div className="spec-badge">
                  <span className="icon">⚙️</span>
                  <span>{car.fuel}</span>
                </div>
                <div className="spec-badge">
                  <span className="icon">🔄</span>
                  <span>{car.transmission}</span>
                </div>
                <div className="spec-badge">
                  <span className="icon">📅</span>
                  <span>{car.year}</span>
                </div>
              </div>

              <div className="location-row">
                <span className="location-pin">📍</span>
                <span className="location-text">{car.location}</span>
              </div>

              {car.condition && (
                <div className="condition-tag">
                  <span className="tag-dot">●</span>
                  {car.condition}
                </div>
              )}

              <div className="price-action-row">
                <div className="price-block">
                  <span className="price-amount">{car.price}</span>
                  <span className="emi-text">EMI from ₹{(parseFloat(car.price.replace(/[^0-9.]/g, '')) * 100000 / 60 / 1000).toFixed(1)}k/mo</span>
                </div>
                <button className="details-btn">
                  <span>Details</span>
                  <span className="arrow">→</span>
                </button>
              </div>
            </div>
          </Link>
        ))}
      </div>
    </div>
  );
};

export default ModelPage;